// extracted by mini-css-extract-plugin
export var chevronIcon = "_81-2";
export var teamName = "_81-1";
export var teamSwitcherButton = "_81-0";